import Plannings from "./plannings.coffee"
import SavePlannings from "./save_plannings.coffee"
import PlanningsCreationWithXslx from "./plannings_create_with_xslx.coffee"

$(document).on 'turbolinks:load', ->
  new Plannings.add_listeners()
  new SavePlannings().handler_events()
  new PlanningsCreationWithXslx().handler_events()
